import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_23: FaireProductEntity = {
  token: "catalog_prod_prod-23",
  type: "product",
  name: "Cupcake Toppers - Assorted Celebration - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 74.22,
  msrpDollars: 185.55,
  sku: "CO0023",
  caseSize: 12,
  material: "Cotton",
  collectionToken: "col_confetti-cake",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 63,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_garden-outdoor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
